module.exports = "<svg preserveAspectRatio=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 583 95\">\n    <polygon id=\"Shape\"  points=\"583 52 583 95 0 95\"></polygon>\n    <polygon id=\"Shape\"  points=\"2.60421025e-14 0 0 94.8556358 583 51.3895917 583 86\"></polygon>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shapes/mountain.svg
// module id = 2821
// module chunks = 0